(function() { window.GUID_7b31598d_c3b4_4a67_856b_278ac974741c = { getGuid: function() { return "7b31598d-c3b4-4a67-856b-278ac974741c"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let NotificationTemplateGroupValue;
        (function (NotificationTemplateGroupValue) {
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["Undefined"] = 0] = "Undefined";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["GenericMessage"] = 1] = "GenericMessage";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["Tournament"] = 2] = "Tournament";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["League"] = 3] = "League";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["ScoreKeeper"] = 4] = "ScoreKeeper";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["Manager"] = 5] = "Manager";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["CompuSport"] = 6] = "CompuSport";
            NotificationTemplateGroupValue[NotificationTemplateGroupValue["CantDisable"] = 7] = "CantDisable";
        })(NotificationTemplateGroupValue = Enumeration.NotificationTemplateGroupValue || (Enumeration.NotificationTemplateGroupValue = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NotificationTemplateGroupValue.pre.js.map
